import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import { useNavigate } from 'react-router-dom'
interface ProtocolProps {
  onChange?: (value: boolean) => void
  value?: boolean
}

const Protocol = (props: ProtocolProps) => {
  const { onChange, value } = props;
  const { t } = useTranslation();
  const navigate = useNavigate()
  return (
    <div
      className='cursor-pointer text-[#666666] align-middle leading-[22px] '
      style={{ lineHeight: '22px' }}
      onClick={() => onChange?.(!value)}
    >
      {
        value
          ? <img className='inline-block mr-2 w-4 h-4 align-middle' src={preFixImgUrl('573929b44e962104a65f6a3cf3bd4126.png')} />
          : <img className='inline-block mr-2 w-4 h-4 align-middle' src={preFixImgUrl('f0cf9d6693874eb4c9ba3ad941913b07.png')} />
      }
      <LangText lngKey='ce49788a' className='align-middle inline text-[14px]'>{t('ce49788a')}</LangText>
      &nbsp;
      <LangText
        lngKey='39d02547'
        className='text-[#FF4D4F] align-middle inline text-[14px]'
        onClick={(e) => {
          e.stopPropagation();
          navigate('/terms');
         }}
      >
        {t('39d02547')}
      </LangText>
      &nbsp;
      <LangText lngKey='455ee77c' className='align-middle inline text-[14px]'>{t('455ee77c')}</LangText>
      &nbsp;
      <LangText
        lngKey='06b9b593'
        className='text-[#FF4D4F] align-middle inline text-[14px]'
        onClick={(e) => {
          e.stopPropagation();
          navigate('/privacy');
        }}
      >
        {t('06b9b593')}
      </LangText>
    </div>
  )
}

export default Protocol